module.exports = __webpack_public_path__ + "media/images/common/icon/icon-dots-43a96786c84e292cf689c7b7e726ea06.svg";